// extracted by mini-css-extract-plugin
export default {"caption":"BreadCrumbItem_caption__5aHC8"};